<template>
  <wb-card
    variant="dark-grey"
    :class="[selectionCardClasses, brandClass(false)]"
    @click="check"
  >
    <wb-checkbox-control theme="dark" class="selection-card-checkbox">
      <label>
        <input type="checkbox" :name="alt" :checked="checked" />
      </label>
    </wb-checkbox-control>
    <img
      :src="image"
      class="selection-card__image"
      :class="brandClass(true)"
      :alt="alt"
    />
    <h3 v-if="!brand" class="wb-type-copy selection-card__name">
      {{
        car !== undefined && car % 2 === 0
          ? 'Very very very huge C-Class Estate name'
          : 'C-Class Estate'
      }}
    </h3>
  </wb-card>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';

import { useMediaQuery } from '../../composables/media-query.composable';

export default defineComponent({
  name: 'otb-selection-card',
  props: {
    car: Number,
    brand: Object,
  },
  setup(props) {
    const { isMobile } = useMediaQuery();
    const checked = ref(false);

    const selectionCardClasses = computed(() => {
      let classes = checked.value ? 'selection-card--checked' : '';

      classes +=
        !isMobile.value && !props.brand
          ? ' selection-card--desktop wb-grid-col-mq1-12 wb-grid-col-mq3-3'
          : ' selection-card';

      return classes;
    });

    const image = computed(() => {
      return props.brand
        ? props.brand.image
        : isMobile.value
        ? require(`../../assets/img/default-car.png`)
        : require(`../../assets/img/default-car-front-side.png`);
    });

    const alt = computed(() => {
      return props.brand ? props.brand.name : `default-car-${props.car}`;
    });

    const brandClass = (img) => {
      return props.brand && img
        ? 'selection-card__image--white'
        : props.brand && !img
        ? 'selection-card--brand'
        : '';
    };

    const check = (e) => {
      e.preventDefault();
      checked.value = !checked.value;
    };

    return {
      checked,
      selectionCardClasses,
      image,
      alt,
      brandClass,
      check,
    };
  },
});
</script>

<style scoped lang="scss" src="./selection-card.scss"></style>
